import { useContext } from "react";

import { ModalPaymentContext } from "src/contexts/modalPayment";

export const useModalPayment = () => {
  const context = useContext(ModalPaymentContext);

  if (context === undefined)
    {throw new Error("useModalPayment must be used within ModalPaymentProvider");}

  return context;
};
